{
  "pending": "nerešeno"
}
